export const addQueryStringParameterToUrl = (
  baseUrl: string,
  queryStringParameter: {
    name: string;
    value: string;
  },
) => {
  const { name, value } = queryStringParameter;

  const url = `${baseUrl}${baseUrl.indexOf("?") !== -1 ? "&" : "?"}${name}=${value}`;

  return url;
};
